import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=604986ba&scoped=true"
import script from "./Todos.vue?vue&type=script&lang=js"
export * from "./Todos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604986ba",
  null
  
)

export default component.exports